module.exports = __webpack_public_path__ + "a64b5ab473fce706b4b8b4df0afc7238.png";